



<template>
  <card title="Acompanhamento de Denúncia">
    <template slot="content">
      <form @submit.prevent="obtemDenunciaPorProtocolo">
        <h3 class="cor">Consulte o andamento de sua denúncia</h3>
        <meta-text
          class="cor"
          id="consulta"
          name="consulta"
          label="Protocolo da denúncia"
          v-model="formulario.consulta"
          placeholder="Digite seu protocolo"
          required
          :pattern="'20[0-9]{2}BR[0-9A-Za-z]{6}'"
          :maxlength="12"
        >
        </meta-text>
        <div class="row justify-content-end">
          <div class="col-md-2">
            <button type="submit" class="btn btn-success btn-block">
              Pesquisar
            </button>
          </div>
        </div>
      </form>
    </template>
  </card>

</template>
<script>
import MetaText from 'meta-text'
import Card from './templates/Card.vue'
import Utils from '@/mixins/utils'

export default {
  name: 'ConsultaDenuncia',

  inject: ['$validator'],

  components: {
    MetaText,
    Card,
  },

  mixins: [
    Utils,
  ],

  data() {
    return {
      formulario: {
        consulta: '',
      },
    };
  },

  mounted() {
    document.getElementById('consulta').focus();
  },

  methods: {
    async obtemDenunciaPorProtocolo() {
      try {
        if (!this.formulario.consulta) {
          this.customAlert(
            'Atenção!',
            'Por favor, preencha todos os campos.',
            'warning',
          );
        } else {
          this.$parent.loading = true;
          const { data: response } = await this.$http.get(`/denuncias/${this.formulario.consulta}`);
          this.denuncias = response;
            if (this.denuncias == '') {
              this.customAlert(
                'Atenção!',
                'Protocolo inexistente.',
                'warning',
              );
            } else {
              this.$router.push({ path:`/denuncia/acompanhamento/${this.formulario.consulta}`});
            }
        }
        } catch (e) {
          this.customAlert(
            'Ocorreu um erro!',
            'Entre em contato com o administrador do sistema.',
            'error',
          )
        } finally {
          this.$parent.loading = false;
        }
      },
      fecharModal () {
        this.$refs.teste.hide();
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/ConsultaDenuncia.vue